import { makeStyles } from '@material-ui/core/styles';
import { THEME } from 'GlobalStyles';

export const useStyles = makeStyles(theme => ({
  tightBottom: {
    marginBottom: 0
  },
  tightMargin: {
    margin: theme.spacing(0.25, 0)
  },
  fieldGroup: {
    marginBottom: theme.spacing(0.5)
  },
  groupWithHint: {
    marginBottom: theme.spacing(3)
  },
  notesContainer: {
    marginTop: theme.spacing(2)
  },
  inputSpacing: {
    marginBottom: theme.spacing(1)
  },
  divider: {
    height: 1,
    margin: theme.spacing(1.5, 0)
  },
  noteWarning: {
    textTransform: 'uppercase'
  }
}));

export const styles = {
  emptyStateImage: {
    margin: THEME.spacing(4, 0)
  },
  helperIcon: {
    marginRight: THEME.spacing(0.5)
  }
};
